import type { DemandLine } from '@/services/demand'

export type DemandDetailKpis = {
  lineCount: number
  totalQty: number
  uniqueVariants: number
  packagingPairs: number
}

export function computeDemandDetailKpis(
  lines: Array<
    Pick<DemandLine, 'variant_id' | 'quantity' | 'assembly_type' | 'ista_level'>
  >,
): DemandDetailKpis {
  const variants = new Set<string>()
  const packs = new Set<string>()
  let totalQty = 0
  for (const line of lines) {
    variants.add(line.variant_id)
    packs.add(`${line.assembly_type}|${line.ista_level}`)
    totalQty += Number(line.quantity) || 0
  }
  return {
    lineCount: lines.length,
    totalQty,
    uniqueVariants: variants.size,
    packagingPairs: packs.size,
  }
}
